import PropTypes from 'prop-types';
import { createContext, useCallback, useState } from 'react';

const initialState = {
	isDrawerOpen: true,
	isRightDrawerOpen: false,
	isStickCall: false,
	onToggleDrawer: () => {},
	onToggleRightDrawer: () => {},
	onToggleStickCall: () => {},
};

export const InterfaceContext = createContext(initialState);

export const InterfaceProvider = ({ children, defaults }) => {
	const onToggleDrawer = useCallback((open) => {
		setState((state) => ({
			...state,
			isDrawerOpen: open === undefined ? !state.isDrawerOpen : !!open,
		}));
	}, []);

	const onToggleRightDrawer = useCallback((open) => {
		setState((state) => ({
			...state,
			isRightDrawerOpen: open === undefined ? !state.isRightDrawerOpen : !!open,
		}));
	}, []);

	const onToggleStickCall = useCallback((open) => {
		setState((state) => ({
			...state,
			isStickCall: open === undefined ? !state.isStickCall : !!open,
		}));
	}, []);

	const [state, setState] = useState({
		...initialState,
		...defaults,
		onToggleDrawer,
		onToggleRightDrawer,
		onToggleStickCall,
	});

	return (
		<InterfaceContext.Provider value={state}>
			{children}
		</InterfaceContext.Provider>
	);
};

InterfaceProvider.propTypes = {
	children: PropTypes.node,
	defaults: PropTypes.shape({
		isDrawerOpen: PropTypes.bool,
		isRightDrawerOpen: PropTypes.bool,
		isStickCall: PropTypes.bool,
	}),
};
